import React from "react";
import { useSmartNavigate } from "@/hooks";
import { Space, Button } from "antd";
import { ArrowsAltOutlined, CloseOutlined } from "@ant-design/icons";

export default function OnePageActionBar({ onePageInfo }) {
  const navigate = useSmartNavigate(onePageInfo);

  return (
    <Space>
      <Button
        size="small"
        icon={<ArrowsAltOutlined />}
        onClick={() => {
          window.open(onePageInfo?.innerHref);
        }}
      >
        新页面打开
      </Button>
      <Button
        size="small"
        icon={<CloseOutlined />}
        onClick={() => {
          navigate("../");
        }}
      >
        关闭
      </Button>
    </Space>
  );
}
